import React from 'react';

import { InfoCircleIcon } from '@vlabs/icons';
import {
  Control, SettingsItemWrapper, Fold, Tooltip,
} from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useLicense } from '../LicenseProvider';
import st from './FaceQualitySubForm.module.sass';

function PeopleCountSubForm() {
  const { isFeatureAvailable } = useLicense();
  const isPeopleCountLicenseAvailable = isFeatureAvailable('estimations.people_counter');
  const { t } = useTranslation();
  const { control } = useFormContext();

  const peopleCountTitle = (
    <div className={st.FoldTitle}>
      <h5>{t('handlers:policies.detect_policy.estimate_people_count.estimate')}</h5>
      {!isPeopleCountLicenseAvailable && (
        <Tooltip
          className="Tooltip_ui"
          data-tooltip-content={t('handlers:policies.detect_policy.tooltip.people count license is required')}
          tooltipProps={{ effect: 'solid' }}
        >
          <InfoCircleIcon />
        </Tooltip>
      )}
    </div>
  );
  return (
    <Fold
      control={control}
      disabled={!isPeopleCountLicenseAvailable}
      isOpen={useWatch({ name: 'estimate_people_count.estimate' })}
      name="estimate_people_count.estimate"
      switch
      testId="estimate_people_count"
      title={peopleCountTitle}
    >
      <SettingsItemWrapper
        title={t('handlers:policies.detect_policy.estimate_people_count.people_coordinates')}
      >
        <Control.Switch
          control={control}
          name="estimate_people_count.people_coordinates"
        />
      </SettingsItemWrapper>
    </Fold>
  );
}

export { PeopleCountSubForm };
